package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class GameTable(
    @SerialName("id")
    val id: String,

    @SerialName("universe_id")
    val universeId: String,

    @SerialName("code")
    val code: String,

    @SerialName("name")
    val name: String = "",

    @SerialName("game_master_id")
    val gameMasterId: String,

    @SerialName("created_at")
    val createdAt: Instant,

    @SerialName("universe_config")
    val universeConfig: UniverseConfig = UniverseConfig()
) {
    val resolvedConfig: UniverseConfig
        get() = resolveUniverseConfig(universeConfig)
}
